/**
 * Check if the DOM has fully loaded and run a function
 * @param {function} callback
 */
const ready = (callback) => {
    if(document.readyState != 'loading') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
}

ready(() => {
    const body = document.body,
        mainNavigationWrapper = document.getElementById('header'),
        openNavMenuBtn = mainNavigationWrapper.querySelector('#open-nav-menu'),
        closeNavMenuBtn = mainNavigationWrapper.querySelector('#close-nav-menu'),
        mobileMenu = mainNavigationWrapper.querySelector('#mobile-menu');


    const wpcf7Form = document.querySelectorAll('.wpcf7-form');
    if ( wpcf7Form ) {
        wpcf7Form.forEach(form => {
            form.removeAttribute('novalidate');
        });

        const cvUploadBtn = document.getElementById('cv');
        
        if (cvUploadBtn) {
            const fileChosen = document.getElementById('file-chosen');
            cvUploadBtn.addEventListener('change', (e) => {
                if ( e.target.files[0] ) {
                    fileChosen.innerText = e.target.files[0].name
                } else {
                    fileChosen.innerText = "";
                }
            })
        }
    } 

    const textareaResizable = document.querySelectorAll('.resize-on-newline');

    if ( textareaResizable ) {
        textareaResizable.forEach(textarea => {
            textarea.setAttribute("style", "height:" + (textarea.scrollHeight) + "px;overflow-y:hidden;");
            textarea.addEventListener("input", OnInput, false);
        })

        function OnInput() {
            this.style.height = "auto";
            this.style.height = (this.scrollHeight) + "px";
        }
    }


    function hideEl(el) {
        el.classList.remove("block");
        el.classList.add("hidden");
    }

    function showEl(el) {
        el.classList.remove("hidden");
        el.classList.add("block");
    }

    openNavMenuBtn.addEventListener('click', () => {
        hideEl(openNavMenuBtn);
        showEl(closeNavMenuBtn);
        showEl(mobileMenu);
    });

    closeNavMenuBtn.addEventListener('click', () => {
        showEl(openNavMenuBtn);
        hideEl(closeNavMenuBtn);
        hideEl(mobileMenu);
    });

    // Masonry grid
    if ( document.querySelector('.masonry-grid-layout') ) {
        const masonryGridEl = document.querySelector('.masonry-grid-layout');
        const msnry = new Masonry(masonryGridEl, {
            itemSelector: '.grid-item',
            percentPosition: true,
            horizontalOrder: true
        });
    }

    // custom cursor
    const circle = document.querySelector('.cursor-circle');
    const circleDot = document.querySelector('.cursor-dot');
    window.addEventListener('mousemove', mouseMoveHandler);
    window.addEventListener('mousedown', mouseDownHandler);
    window.addEventListener('mouseup', mouseUpHandler);

    function mouseMoveHandler(e) {
        setTimeout(() => {
            circleDot.style.left = e.clientX - circleDot.offsetWidth / 2 + "px";
            circleDot.style.top = e.clientY - circleDot.offsetHeight / 2 + "px";
        }, 30);
        circle.style.left = e.clientX - circle.offsetWidth / 2 + "px";
        circle.style.top = e.clientY - circle.offsetHeight / 2 + "px";

        setTimeout(() => {
            circleDot.style.left = e.clientX - circleDot.offsetWidth / 2 + "px";
            circleDot.style.top = e.clientY - circleDot.offsetHeight / 2 + "px";
        }, 40);
   
    }

    function mouseUpHandler(e) {
        circle.style.transform = "scale(1)";
    }

    function mouseDownHandler() {
        circle.style.transform = "scale(1.5)";
    }

    // cookies popup
    const cookiesPopup = document.getElementById('cookies-popup');
    const closeCookiesPopup = document.getElementById('close-cookies-popup');

    const setCookie = (name, value, days = 7, path = '/') => {
        const expires = new Date(Date.now() + days * 864e5).toUTCString()
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
      }
    
    const getCookie = (name) => {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=')
            return parts[0] === name ? decodeURIComponent(parts[1]) : r
        }, '')
    }

    if ( cookiesPopup && closeCookiesPopup ) {
        closeCookiesPopup.addEventListener('click', () => {
            setCookie('cookie-popup-closed', '1', 365);
            cookiesPopup.classList.add('hidden');
        });
    }


});